<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{this.folderName}}</li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">{{this.folderName}}</div>
      </div>
      <div class="card-body">
        <ul class="list-news">
          <li v-for="(folder,index) in folders.slice(startFiles,endFiles)" v-bind:key="index">
            <!-- <a v-bind:href="'/#/NewsList/'+folderName+'/'+folder.fields.Category"> -->
            <a v-if="folderName == 'supervisory pilots'" v-bind:href="'/#/staticfolderlist/'+folder">
              <div class="icon">
                <span class="fa-stack">
                  <i class="fa fa-folder fa-stack-1x"></i>
                </span>
              </div>
              <div class="con">
                <div class="title">{{folder}}</div>
                <div class="text">{{$moment(folder.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
            <!-- <a v-else-if="folderName == 'trainingmaterial'" v-bind:href="'/#/d3folderlist/'+folderName+'/'+folder">
              <div class="icon">
								<span class="fa-stack">
									<i class="fa fa-folder fa-stack-1x"></i>
								</span>
							</div>
              <div class="con">
                <div class="title">{{folder}}</div>
                <div class="text">{{$moment(folder.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>-->
            <a v-else v-bind:href="'/#/d2folderlist/'+folderName+'/'+folder">
              <div class="icon">
                <span class="fa-stack">
                  <i class="fa fa-folder fa-stack-1x"></i>
                </span>
              </div>
              <div class="con">
                <div class="title">{{folder}}</div>
                <div class="text">{{$moment(folder.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <div class="func-tool">
          <div class="pagination-num">
            {{currenPage}}/{{getTotalPage}}
            <span>Total:{{total}}</span>
          </div>
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <a class="page-link" v-on:click="getLastPage(currenPage)">
                <i class="fa fa-angle-left"></i>
              </a>
            </li>
            <li class="page-item" v-for="(page,index) in getTotalPage" v-bind:key="index">
              <a class="page-link" v-on:click="getPagination(index)">{{index+1}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" v-on:click="getNextPage(currenPage)">
                <i class="fa fa-angle-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StaticFolderList',
  data: () => ({
    startFiles: 0,
    endFiles: 15,
    numberPerPage: 15,
    currenPage: 1,
    total: 0,
    folderName: '',
    category: '',
    folders: []
  }),
  created () {
    this.folderName = this.$route.params.name
    this.category = this.$route.params.category
    if (
      this.folderName === 'supervisory pilots' && this.category === undefined) {
      this.folders = this.GLOBAL.pilotportal['pilot']
    } else {
      this.folders = this.GLOBAL.pilotportal['category']
    }
    this.total = this.folders.length
  },
  methods: {
    getPagination (page) {
      this.currenPage = page + 1
      this.startFiles = page * this.numberPerPage
      this.endFiles = (page + 1) * this.numberPerPage
    },
    getLastPage (page) {
      if (page > 1) {
        this.currenPage = page - 1
        this.startFiles = (page - 2) * this.numberPerPage + 1
        this.endFiles = (page - 1) * this.numberPerPage
      }
    },
    getNextPage (page) {
      if (page < this.getTotalPage) {
        this.currenPage = page + 1
        this.startFiles = page * this.numberPerPage
        this.endFiles = (page + 1) * this.numberPerPage
      }
    }
  },
  computed: {
    getTotalPage () {
      return Math.ceil(this.folders.length / this.numberPerPage)
        ? Math.ceil(this.folders.length / this.numberPerPage) : 1
    }
  }
}
</script>
